import { useSidebar } from '@/components/sidebar/SidebarContext';
import { DARK_MODE_COLORS, LIGHT_MODE_COLORS } from '@/styles/darkModeColors';

/**
 * Custom hook for consistent dark mode implementation
 * Returns theme state and color utilities
 */
export const useDarkMode = () => {
  const { theme } = useSidebar();
  const isDark = theme === 'dark';

  return {
    isDark,
    theme,
    colors: isDark ? DARK_MODE_COLORS : LIGHT_MODE_COLORS,
    // Utility classes for common patterns
    classes: {
      bg: {
        primary: isDark ? 'bg-[#1a1f2e]' : 'bg-white',
        secondary: isDark ? 'bg-[#2b3544]' : 'bg-[#f8f9fa]',
        tertiary: isDark ? 'bg-[#242b3d]' : 'bg-gray-100',
      },
      border: {
        default: isDark ? 'border-gray-700' : 'border-gray-200',
        subtle: isDark ? 'border-gray-800' : 'border-gray-100',
      },
      text: {
        primary: isDark ? 'text-gray-100' : 'text-gray-900',
        secondary: isDark ? 'text-gray-300' : 'text-gray-600',
        muted: isDark ? 'text-gray-400' : 'text-gray-500',
      },
    },
  };
};
